module.exports = __webpack_public_path__ + "static/media/fondoLlenarElEspacioStudy.dc8680d1.svg";